import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiTooltipDirective } from '@siemens/element-ng/tooltip';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { IssueReportService } from '../../services/issue-report.service';

/**
 * Header action button that links to the JUNO GitHub Issues page.
 * Placed in <si-header-actions> alongside the theme toggle and user menu.
 */
@Component({
    selector: 'app-support-link',
    templateUrl: './support-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, SiTooltipDirective, SiIconComponent]
})
export class SupportLinkComponent {
    private readonly issueReportService = inject(IssueReportService);

    protected readonly issuesUrl = this.issueReportService.issuesUrl;
}
